import { render, staticRenderFns } from "./SidebarMenuContent.vue?vue&type=template&id=5f12a0ec&scoped=true"
import script from "./SidebarMenuContent.vue?vue&type=script&lang=ts"
export * from "./SidebarMenuContent.vue?vue&type=script&lang=ts"
import style0 from "./SidebarMenuContent.vue?vue&type=style&index=0&id=5f12a0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12a0ec",
  null
  
)

export default component.exports